import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-daohangqiehuan",
  "use": "icon-daohangqiehuan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-daohangqiehuan\"><defs><style type=\"text/css\"></style></defs><path d=\"M927 617H97c69.6-103.1 212-132 261.3-139 10.7-1.6 19.5-9.2 22.9-19.5l0.2-0.2c10-30.5 38.3-51.2 70.1-51.2h120.3c31.8 0 60.1 20.7 70.1 51.2 3.7 10.6 12.5 18.2 23.2 19.7 49.7 6.7 192.6 35 261.9 139z\" fill=\"#EE2223\" p-id=\"3362\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol